import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { CardActionArea, CardContent } from "@mui/material";
import { PersonOutlined } from "@mui/icons-material";

function PractitionerCard({ setPage, page, data }) {
  data = data ?? page.praticien;
  const handleClick = () => {
    if (!page.valid) {
      page.page === 2
        ? setPage({ ...page, page: 3, praticien: data })
        : setPage({ ...page, page: 2, praticien: null, date: "" });
    }
  };

  return (
    <Card
      style={{ cursor: page.page !== 5 ? "pointer" : "default" }}
      sx={{ "&:hover": { boxShadow: 4 } }}
    >
      <CardActionArea
        onClick={(event) => handleClick()}
        style={{ width: "360px" }}
      >
        <CardContent>
          <Stack direction={"row"} alignItems="center">
            <Stack>
              {data.Photo ? (
                <Avatar
                  alt={data.Name}
                  src={"data:image/jpg;base64," + data.Photo}
                  sx={{ width: 96, height: 96 }}
                />
              ) : (
                <Avatar alt={data.Name} sx={{ width: 96, height: 96 }}>
                  <PersonOutlined fontSize={"large"} />
                </Avatar>
              )}
            </Stack>
            <Stack direction="column" ml={2}>
              <Typography variant="h5" gutterBottom>
                {data.Name}
              </Typography>
              <Typography variant="h6">{data.Firstname}</Typography>
              <Typography variant="h6">{data.Location}</Typography>
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default PractitionerCard;
